var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4713 6.58508C21.2515 4.80497 24.1377 4.80497 25.9178 6.58508C27.6979 8.36519 27.6979 11.2513 25.9178 13.0314L24.8815 14.0677C24.5886 14.3606 24.5886 14.8354 24.8815 15.1283C25.1744 15.4212 25.6493 15.4212 25.9422 15.1283L26.9785 14.0921C29.3444 11.7262 29.3444 7.8903 26.9785 5.52441C24.6125 3.15853 20.7766 3.15853 18.4107 5.52441L13.1023 10.8327C10.7364 13.1985 10.7364 17.0344 13.1023 19.4003C13.3952 19.6932 13.8701 19.6932 14.163 19.4003C14.4559 19.1074 14.4559 18.6325 14.163 18.3396C12.3828 16.5595 12.3828 13.6734 14.163 11.8933L19.4713 6.58508ZM19.9006 12.6025C19.6077 12.3097 19.1328 12.3097 18.8399 12.6026C18.547 12.8955 18.547 13.3703 18.8399 13.6632C20.6201 15.4433 20.6201 18.3294 18.8399 20.1095L13.5316 25.4178C11.7514 27.1979 8.86525 27.1979 7.0851 25.4178C5.30497 23.6377 5.30497 20.7516 7.0851 18.9715L8.12139 17.9352C8.41429 17.6423 8.41429 17.1674 8.1214 16.8745C7.82851 16.5816 7.35364 16.5816 7.06074 16.8745L6.02445 17.9108C3.65852 20.2767 3.65852 24.1126 6.02445 26.4784C8.39038 28.8443 12.2263 28.8443 14.5922 26.4784L19.9006 21.1702C22.2665 18.8043 22.2665 14.9684 19.9006 12.6025Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.41f3249bbb8011f4b09c542e43d9236e.svg";
export { ForwardRef as ReactComponent };